import { apiError } from '../../utils/errors';

export const postThirdParty = async (
  urlSlug: string,
  trackingId: string,
  responses: Record<string, unknown>,
): Promise<void> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/third-parties/${urlSlug}/${trackingId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      responses,
    }),
  });

  if (!response.ok) {
    const responseJson = await response.json();
    throw apiError(response.status, responseJson?.message || 'Failed to submit third parties', responseJson?.code);
  }
};
